import { useEffect, useState } from "react";
import { MdClose } from "react-icons/md";

type ToastProps = {
  show: boolean;
  type: "success" | "error" | "warning" | "info";
  message: string;
};

export function Toast({ show, type, message }: ToastProps) {
  const [showToast, setShowToast] = useState<boolean>(show);

  useEffect(() => {
    if (!showToast || type === "error") return;
    setTimeout(() => {
      setShowToast(false);
    }, 3000);
  }, [showToast, type]);

  if (!showToast && !type) return null;

  return (
    <div
      className="toast toast-top toast-end"
      onClick={() => setShowToast(false)}
    >
      <div className={`alert alert-${type}`}>
        <div>
          <span>{message}</span>

          {type === "error" && <MdClose />}
        </div>
      </div>
    </div>
  );
}
